module.exports = __webpack_public_path__ + "fonts/3107C8_0_0.608d32e.woff2";